module.exports = __webpack_public_path__ + "8c4986ee4828b47d16f5cd694ef065f2.svg";